let radio_btns: NodeListOf<HTMLInputElement> = document.querySelectorAll(`.c-input--radio--temp`);

if(radio_btns) {
  radio_btns.forEach((target: HTMLInputElement) => {

    target.addEventListener("change", () => {
      let rich = new RichTemp(target);
      rich.Aspect();
      rich.Layout();
    });
  })

}

class RichTemp {

  button: HTMLInputElement;
  aspect: string;
  aspectNum: number
  layout: string;
  layoutNum: number;

  constructor(button: HTMLInputElement) {
    this.button = button;
    this.aspect = this.button.dataset.aspect!;
    this.aspectNum = Number(this.aspect);
    this.layout = this.button.dataset.layout!;
    this.layoutNum = Number(this.layout);
  }

  Aspect(): void {
    const dzRich: HTMLElement = document.querySelector(".p-form--dropzoon--rich")!;
    const dzNormalRich: HTMLElement = document.querySelector(".p-form--dropzoon__normal--rich")!;
    if (this.aspectNum > 5) {
      dzRich.classList.add("p-form--dropzoon--rich--2");
      dzNormalRich.classList.add("p-form--dropzoon__normal--rich--2");
    } else {
      dzRich.classList.remove("p-form--dropzoon--rich--2");
      dzNormalRich.classList.remove("p-form--dropzoon__normal--rich--2");
    }
  }

  Layout(): void {
    const linkBox: HTMLElement = document.querySelector(".js-rich-link-box")!;
    const link: NodeListOf<HTMLElement> = document.querySelectorAll(".js-rich-link");
    linkBox.style.display = "grid";
    for(let i = 0; i < link.length; i ++) {
      if (i < this.layoutNum) {
        link[i].style.display = "grid";
      } else {
        link[i].style.display = "none";
      }
    }
  }

}
